import React, { Component } from "react";
import {
  Table,
  Badge,
  ToggleButtonGroup,
  ToggleButton,
  Container,
  Row,
  Col,
} from "react-bootstrap";
import { numberWithCommas } from "../../../../helpers/dataHelpers";
import { gold_medal, silver_medal, bronze_medal } from "../../../../images";
import { connect } from "react-redux";

import {
  GetPreviousMonthAverageAreaV4,
  GetPreviousMonthAverageClusterV4,
  GetPreviousMonthAverageBranchV4,
} from "../../../../store/actions/reports-v4/previous_month_average_service_actions";
import ranked from "ranked";

import { GetMasterAreas } from "../../../../store/actions/crdm_service_actions";
import { RankingContext } from "./ranking_context";
import { Button } from "react-bootstrap";
import { CenteredSpinner } from "../../../../components/extensions";

class BranchRankingSpecific extends Component {
  state = {
    isLoading: false,
    filterBy: "piece",
  };

  componentDidMount() {
    this.appendItemData();
  }

  appendItemData = () => {
    var toView =
      this.props.branch_codes.length > 0
        ? this.props.branch_codes
        : this.context.branch_codes;

    this.setState({ isLoading: true });

    this.premiseGetPreviousMonthAverageBranch({
      month: this.props.pma_month,
      year: this.props.pma_year,
      branch_codes: toView,
    }).then((r) => {
      this.setState({ isLoading: false });
    });
  };

  _bindSummaries = (branchList) => {
    const rankFn = (item) => item.averagePieces;
    let itemRank = ranked.ranking(branchList, rankFn, {
      strategy: "ordinal",
    });

    return itemRank.map((rItem, idx) => {
      return {
        id: idx,
        rank: rItem.rank,
        name: `${rItem.item.branchName}`,
        code: rItem.item.branchCode,
        totalPieces: rItem.item.averagePieces,
        totalAmount: rItem.item.averagePrincipal,
      };
    });
  };

  handleSelectedFilterBy = (val) => {
    this.setState({ filterBy: val });
    this.appendItemData();
  };

  renderTable = (context) => {
    return (
      <div>
        <div className="mt-3" style={{ maxHeight: 300, overflow: "auto" }}>
          <Table hover responsive size="sm" variant="light" striped>
            <thead>
              <tr>
                {context.state.area_headers.map((data) => {
                  return <th key={data.id}>{data.name}</th>;
                })}
              </tr>
            </thead>
            <tbody>
              {this._bindSummaries(this.props.branchSummaries).map((data) => {
                return (
                  <tr key={data.id}>
                    <td>
                      <div>
                        <div style={{ display: "inline" }} className="mr-2">
                          {data.rank}
                        </div>
                        <img
                          alt="gold"
                          hidden={data.rank !== 1}
                          height="21"
                          src={gold_medal}
                        />
                        <img
                          alt="silver"
                          hidden={data.rank !== 2}
                          height="21"
                          src={silver_medal}
                        />
                        <img
                          alt="bronze"
                          hidden={data.rank !== 3}
                          height="21"
                          src={bronze_medal}
                        />
                      </div>
                    </td>
                    <td>
                      <span>
                        {data.name}
                        <span className="ml-1">
                          <Badge variant="secondary">{data.code}</Badge>
                        </span>
                      </span>
                    </td>
                    <td>
                      <div
                        style={{
                          display: "inline",
                          color: "#2f3542",
                          fontWeight: "bold",
                        }}
                      >
                        {numberWithCommas(data.totalPieces)}
                      </div>
                      {`/${numberWithCommas(
                        Math.round(data.totalAmount / 50) * 50
                      )}`}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </div>
        <caption className="small">
          <span className="m-3">Ranked by</span>
          <ToggleButtonGroup
            onChange={this.handleSelectedFilterBy}
            size="sm"
            name="filterByRadio"
            type="radio"
            value={this.state.filterBy}
          >
            <ToggleButton variant="light" value="piece">
              Piece
            </ToggleButton>
            <ToggleButton variant="light" value="principal">
              Principal
            </ToggleButton>
          </ToggleButtonGroup>
        </caption>
      </div>
    );
  };

  render() {
    return this.state.isLoading ? (
      <CenteredSpinner />
    ) : (
      <Container>
        <Row>
          <Col>
            <Button
              variant="dark"
              size="sm"
              onClick={this.context.gotoClusterView}
            >
              Overall Ranking
            </Button>
          </Col>
        </Row>
        <Row>
          <Col>{this.renderTable(this.context)}</Col>
        </Row>
      </Container>
    );
  }

  premiseGetPreviousMonthAverageCluster = (data) => {
    return this.props.GetPreviousMonthAverageClusterV4(data);
  };

  premiseGetPreviousMonthAverageArea = (data) => {
    return this.props.GetPreviousMonthAverageAreaV4(data);
  };

  premiseGetPreviousMonthAverageBranch = (data) => {
    return this.props.GetPreviousMonthAverageBranchV4(data);
  };

  premiseGetMasterAreas = () => {
    return this.props.GetMasterAreas();
  };
}

const mapStateToProps = (state) => {
  return {
    pma_month: state.previous_month_average.pma_month,
    pma_year: state.previous_month_average.pma_year,

    clusterSummaries: state.previous_month_average.clusterSummaries,
    branchSummaries: state.previous_month_average.branchSummaries,
    master_cluster: state.crdm.master_cluster,
    master_area: state.crdm.master_area,
    pepp_hierarchy: state.crdm.pepp_hierarchy,
  };
};

const mapDispatchToProps = {
  GetPreviousMonthAverageAreaV4: GetPreviousMonthAverageAreaV4,
  GetPreviousMonthAverageClusterV4: GetPreviousMonthAverageClusterV4,
  GetMasterAreas: GetMasterAreas,
  GetPreviousMonthAverageBranchV4: GetPreviousMonthAverageBranchV4,
};

BranchRankingSpecific.contextType = RankingContext;

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BranchRankingSpecific);
